import React, { Component } from 'react';
import ModalContext from './ModalContext';
import ReactModal from 'react-modal';
class ModalProvider extends Component {
    constructor() {
        super(...arguments);
        this.showTarget = (modalComponent, modalType, modalId, props = {}) => {
            this.setState(this.initialState, () => {
                this.setState({
                    modalComponent,
                    modalId,
                    modalType,
                    isOpen: true,
                    props
                });
            });
        };
        this.hideTarget = () => this.setState(this.initialState);
        this.initialState = {
            modalComponent: null,
            modalType: null,
            modalId: null,
            isOpen: false,
            props: {},
            showTarget: this.showTarget,
            hideTarget: this.hideTarget
        };
        this.state = this.initialState;
    }
    componentDidMount() {
        ReactModal.setAppElement('#root');
    }
    render() {
        return (React.createElement(ModalContext.Provider, { value: this.state }, this.props.children));
    }
}
export default ModalProvider;
//# sourceMappingURL=ModalProvider.js.map